import React, { Component } from 'react';
import { Col, Container, Row, Card, CardBody, Nav, NavItem, NavLink } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TaxMasterComponent from './components/viewMappedItems';
import HorizontalFormView from '../alternateView/components/alternateView';
import ItemMasterDetails from '../ItemMasterDetails/components/itemMasterDetails';
import "../../global.css";

class ItemMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'tax_master'
    };
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }

    if(tab == 'item_list'){
      window.location.href = "/upload/item_master"
    }
  };

  render() {
    const { t } = this.props;
    const { activeTab } = this.state;

    return (
      <Container>
        
        <Row>
          <Col md={12} id="master_tab_container" className="master_tab_container">
           
                <Nav style={{backgroundColor: '#fff', marginBottom: 6, paddingLeft: 0}} tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active1: activeTab === 'item_list' })}
                      style={activeTab === 'item_list' ? { backgroundColor: '#FEF1CC', margin: 0 } : {}}
                      onClick={() => this.toggleTab('item_list')}
                    >
                      Item List
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active1: activeTab === 'map_tax' })}
                      style={activeTab === 'map_tax' ? { backgroundColor: 'yellow', border: '2px solid darkgoldenrod' } : {}}
                      onClick={() => this.toggleTab('map_tax')}
                    >
                      Map Tax
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={classnames({ active1: activeTab === 'tax_master' })}
                      style={activeTab === 'tax_master' ? { backgroundColor: 'yellow', border: '2px solid darkgoldenrod' } : {}}
                      onClick={() => this.toggleTab('tax_master')}
                    >
                      Tax Master
                    </NavLink>
                  </NavItem>
                </Nav>
              
          </Col>
        </Row>

        
        <Row>
          <Col md={12}>
           
                {activeTab === <ItemMasterDetails/> ? "" : activeTab === 'map_tax' ? "" : <TaxMasterComponent />}
             
          </Col>
        </Row>
      </Container>
    );
  }
}

ItemMaster.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ItemMaster);